import { createFileRoute, Outlet } from '@tanstack/react-router';

const OperatorBlogLayout = () => <Outlet />;

export const Route = createFileRoute('/_protected/operators/blog')({
  component: OperatorBlogLayout,
});
